import {
  AdgroupFormData,
  CampaignFormData,
  optimizationGoal2PridingType,
  PricingType,
  OptimizeGoal
} from '@tt4b/ttam-enums';
import { Ref, computed } from '@vue/composition-api';
import { useStdAdgroupOptimizationGoal, useStdAdgroupIs } from '@tt4b/ttam-hooks';
import { i18n } from './../../../i18n';

export function useTextPropsBillingEvent(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData } = props;
  const { isOptGoalVideoView2s } = useStdAdgroupOptimizationGoal({
    adgroupFormData: adgroupData,
  });
  const billingEvent = computed(() => {
    switch (adgroupData.value?.pricing) {
      case PricingType.CPM:
        return i18n.t('adgroup_billing_cpm');
      case PricingType.CPC:
        return i18n.t('adgroup_billing_cpc');
      case PricingType.OCPM:
        return i18n.t('adgroup_billing_ocpm');
      case PricingType.CPV:
        return isOptGoalVideoView2s.value ? i18n.t('module_adgroup_billing_cpv_2s') : i18n.t('adgroup_billing_cpv');
      case PricingType.OCPC:
        return i18n.t('adgroup_billing_ocpc');
      default:
        return '';
    }
  });
  return {
    billingEvent,
  };
}

export function useInitDataGet(props: { adgroupData: Ref<AdgroupFormData>; campaignData: Ref<CampaignFormData> }) {
  const { adgroupData, campaignData } = props;
  const { isCLA } = useStdAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });
  const { isOptGoalConversion } = useStdAdgroupOptimizationGoal({
    adgroupFormData: adgroupData,
  });
  // CLA且og为convert时，出价方式固定是OCPC
  if (isCLA.value && isOptGoalConversion.value) {
    return {
      pricing: PricingType.OCPC,
    };
  }
  const pricing: PricingType = optimizationGoal2PridingType[adgroupData.value?.optimizeGoal] || PricingType.NONE;

  return {
    pricing,
  };
}
